/* ────────────────────────────────────────────────────────────
   DOUBLEBACK — FX Estimate
   Appends a small approximate USD estimate next to MYR prices,
   e.g. "RM347.20 ~ US$83". Display-only: customers still check
   out in MYR (same approach as Ghostboy's "~ US$89" widget).

   - Rate from open.er-api.com (free, no key), cached 12h.
   - Non-blocking: if the rate can't be fetched, nothing shows.
   ──────────────────────────────────────────────────────────── */
(function () {
  var RATE_KEY = 'db_fx_usd_rate';
  var RATE_TTL = 12 * 60 * 60 * 1000; // 12 hours
  var SELECTORS = [
    '.pdp__price',          // product page main price
    '.price',               // product cards / related products
    '.qa-panel__price',     // quick-add panel
    '.line-price',          // cart line items
    '.cart__total-value'    // cart total
  ];

  function cachedRate() {
    try {
      var raw = localStorage.getItem(RATE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || !o.rate || (Date.now() - o.ts) > RATE_TTL) return null;
      return o.rate;
    } catch (e) { return null; }
  }

  function storeRate(rate) {
    try { localStorage.setItem(RATE_KEY, JSON.stringify({ rate: rate, ts: Date.now() })); } catch (e) {}
  }

  /* "RM1,234.00" -> 1234 */
  function parseMYR(text) {
    var m = String(text || '').replace(/,/g, '').match(/RM\s?([0-9]+(?:\.[0-9]+)?)/i);
    return m ? parseFloat(m[1]) : null;
  }

  function fmtUSD(usd) {
    if (!isFinite(usd) || usd <= 0) return '';
    var n = usd >= 10 ? Math.round(usd) : Math.round(usd * 10) / 10;
    return '~ US$' + n;
  }

  function apply(rate) {
    if (!rate) return;
    var nodes = document.querySelectorAll(SELECTORS.join(','));
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el || el.querySelector('.fx-estimate')) continue;
      var amount = parseMYR(el.textContent);
      if (amount == null) continue;
      var span = document.createElement('span');
      span.className = 'fx-estimate';
      span.setAttribute('aria-label', 'Estimated price in US dollars');
      span.textContent = fmtUSD(amount * rate);
      if (span.textContent) el.appendChild(span);
    }
  }

  function boot(rate) {
    apply(rate);
    /* Re-apply after dynamic updates (quick-add, AJAX cart, carousels) */
    var t = null;
    try {
      var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { apply(rate); }, 120);
      });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }

  var r = cachedRate();
  if (r) { boot(r); return; }

  if (window.fetch) {
    fetch('https://open.er-api.com/v6/latest/MYR')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var rate = data && data.rates && data.rates.USD;
        if (rate) { storeRate(rate); boot(rate); }
      })
      .catch(function () { /* silent — no estimate if rate unavailable */ });
  }
})();
